import React from "react";
import { Clock, Users, Flame } from "lucide-react";

export default function RecipeCard({ recipe, onClick }) {
  const imgSrc = recipe.image_base64
    ? `data:image/jpeg;base64,${recipe.image_base64}`
    : null;

  return (
    <button
      onClick={onClick}
      data-testid={`recipe-card-${recipe.id || "unknown"}`}
      className="group text-left w-full bg-[#1C1917] border border-white/5 rounded-2xl overflow-hidden hover:border-amber-500/20 transition-all duration-300"
    >
      <div className="aspect-[4/3] relative overflow-hidden bg-stone-900">
        {imgSrc ? (
          <img
            src={imgSrc}
            alt={recipe.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-stone-700">
            <span className="text-4xl">&#127858;</span>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0C0A09]/80 to-transparent" />
        {recipe.nutrition_per_serving?.calories && (
          <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/60 backdrop-blur-sm text-orange-400 text-[10px] font-semibold px-2 py-1 rounded-full">
            <Flame className="w-3 h-3" />
            {recipe.nutrition_per_serving.calories} kcal
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="text-white font-medium text-sm leading-snug line-clamp-2 mb-2 group-hover:text-amber-500 transition-colors">
          {recipe.title}
        </h3>
        <div className="flex items-center gap-3 text-xs text-stone-500">
          {recipe.total_time && (
            <span className="flex items-center gap-1">
              <Clock className="w-3 h-3" />
              {recipe.total_time}
            </span>
          )}
          {recipe.servings && (
            <span className="flex items-center gap-1">
              <Users className="w-3 h-3" />
              {recipe.servings}
            </span>
          )}
        </div>
        {recipe.dietary_tags?.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-2">
            {recipe.dietary_tags.slice(0, 2).map((tag, i) => (
              <span
                key={i}
                className="bg-stone-800 text-stone-400 text-[10px] px-2 py-0.5 rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </button>
  );
}
